function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";
import classNames from "classnames";
import { withGenericConfig } from "/contexts/generic-config-context";
import PricingInfoIcon from "/static/svg/pricing-info-icon.svg";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants";
import { PRICING_PAGE_FEATURE_INFO_ICON_HOVER } from "/constants/bigbrain-event-types";
import { preventFocusOnMouseDown, setSVGTitle } from "client/services/accessibility/accessibility-service";
import { getFeatureInfoElementID } from "services/pricing/pricing-page/features-service";
import { getPricingDimensions } from "/services/pricing/pricing-page/pricing-page-display-service";
import { withAbTests } from "/contexts/ab-tests-context";
import { StyledFeatureComponent } from "./feature-component.scss";
import PlanFeatureValueComponent from "./plan-feature-value/plan-feature-value-component";
class FeatureComponent extends PureComponent {
    componentDidMount() {
        const { translateOrTranslateWithParam, featureDescription } = this.props;
        setSVGTitle(`#${this.getFeatureInfoID()}`, translateOrTranslateWithParam(featureDescription));
    }
    onMouseEnterToInfoIcon() {
        const { featureName, translate, clusterId } = this.props;
        BigBrain("track", PRICING_PAGE_FEATURE_INFO_ICON_HOVER, {
            placement: "homepage_minisite",
            kind: featureName,
            info1: translate(featureName),
            info3: clusterId
        });
    }
    render() {
        const { featureValuesPerPlan, featureName, featureDescription, plans, translate, translateOrTranslateWithParam, indexInSection } = this.props;
        const { tooltipActive } = this.state;
        const pricingDimensions = getPricingDimensions(plans);
        const { featuresSection: featuresSectionDimensions } = pricingDimensions;
        const { featureWidth, planWidth } = featuresSectionDimensions;
        const featureNameStyle = {
            width: `${featureWidth}%`
        };
        return /*#__PURE__*/ _jsx(VisibilitySensor, {
            partialVisibility: true,
            onChange: this.onFeatureVisibilityChange,
            active: this.shouldTrackVisibilityForFeature(),
            scrollCheck: true,
            children: /*#__PURE__*/ _jsxs(StyledFeatureComponent, {
                className: "feature-component",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "feature-name",
                        onMouseDown: preventFocusOnMouseDown,
                        role: "cell",
                        style: featureNameStyle,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "feature-name-text",
                                children: translate(featureName)
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: classNames("feature-info", {
                                    "tooltip-active": tooltipActive
                                }),
                                id: this.getFeatureInfoID(),
                                onMouseEnter: this.onMouseEnterToInfoIcon,
                                tabIndex: 0,
                                onFocus: this.onTooltipFocus,
                                onBlur: this.onTooltipBlur,
                                onMouseDown: preventFocusOnMouseDown,
                                "aria-label": translateOrTranslateWithParam(featureDescription),
                                children: [
                                    /*#__PURE__*/ _jsx(PricingInfoIcon, {}),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "feature-tooltip-container",
                                        children: /*#__PURE__*/ _jsx(TooltipComponent, {
                                            theme: DARK_THEME,
                                            className: "floating-tooltip",
                                            children: translateOrTranslateWithParam(featureDescription)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    plans.map((plan)=>{
                        const tier = plan.tier;
                        const { value, info } = featureValuesPerPlan[tier];
                        return /*#__PURE__*/ _jsx(PlanFeatureValueComponent, {
                            plan: plan,
                            tier: tier,
                            featureValue: value,
                            featureInfo: info,
                            featureName: featureName,
                            indexInSection: indexInSection,
                            planWidth: planWidth
                        }, tier);
                    })
                ]
            }, featureName)
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "getFeatureInfoID", ()=>{
            const { featureName, indexInSection, sectionName } = this.props;
            return getFeatureInfoElementID(featureName, sectionName, indexInSection);
        });
        _define_property(this, "shouldTrackVisibilityForFeature", ()=>{
            const { onVisible } = this.props;
            return !!onVisible;
        });
        _define_property(this, "onFeatureVisibilityChange", (isVisible)=>{
            if (!isVisible) return;
            const { onVisible, abTests, forcePricing } = this.props;
            const { isAlreadyVisible } = this.state;
            const { callback: onVisibleCallback, onlyOnce } = onVisible;
            if (isAlreadyVisible && onlyOnce) return;
            onVisibleCallback({
                abTests,
                forcePricing
            });
            this.setState({
                isAlreadyVisible: true
            });
        });
        _define_property(this, "onTooltipFocus", ()=>{
            this.onMouseEnterToInfoIcon();
            this.setState({
                tooltipActive: true
            });
        });
        _define_property(this, "onTooltipBlur", ()=>{
            this.setState({
                tooltipActive: false
            });
        });
        this.onMouseEnterToInfoIcon = this.onMouseEnterToInfoIcon.bind(this);
        this.state = {
            isAlreadyVisible: false,
            tooltipActive: false
        };
    }
}
export default withAbTests(withGenericConfig(FeatureComponent));
